import React from "react";
import RevealText from "../Comman/RevealText";

export default function SecureYouNFT() {
  return (
    <>
      <div
        className="tp-hero-3-area tp-hero-3-ptb fix"
        style={{ backgroundImage: "url(assets/img/one/buy_nft_bg.png)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-hero-3-content-box text-center p-relative">
                <RevealText text="Own Your Future – Claim Your NFT Today!" />

                <span className="tp-hero-3-category tp_reveal_anim">
                  You’re just a few steps away from securing your Kryptogram NFT
                  and unlocking exclusive benefits. Select your NFT type below
                  and complete your purchase.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
